document.addEventListener('click', function(event) {
  const link = event.target.closest('[href^="#"]');
  if (!link) return;

  const anchorId = link.getAttribute('href').substring(1);
  const target = document.getElementById(anchorId);
  if (target) {
    event.preventDefault();
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - 40,
      behavior: 'smooth'
    });
  }
});
